import { formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Label } from "reactstrap";
import MenuColorSelect from "../ColorSelect/MenuColorSelect";
import SingleColorSelect from "../ColorSelect/SingleColorSelect";
import MessageFormValidateV2 from "../MessageFormValidateV2";

/**
 * @param {object} props
 * @param {object} props.mainForm
 * @param {string} props.fieldName
 * @param {function} props.t
 * @param {object[]} props.dataList
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isRequired
 * @param {boolean} props.isMultiple
 * @param {?function} props.onChange
 * @param {string} props.title
 * @param {boolean} props.isUseComponents
 * @param {boolean} props.isLabel
 * @param {boolean} props.isPlaintext
 * @param {boolean} props.isError
 * @param {boolean} props.isClearable
 */
const FormSelect = props => {
  const {
    mainForm,
    fieldName,
    t,
    dataList,
    isDisabled,
    isRequired,
    isMultiple,
    onChange,
    title,
    isUseComponents,
    isLabel,
    isPlaintext,
    isError,
    isClearable,
  } = props;

  const {
    formState: { errors, touchedFields },
    control,
    getValues,
  } = mainForm;

  return (
    <div className={`${isLabel ? "mb-1" : ""}`}>
      {isLabel && (
        <Label htmlFor={fieldName}>
          {title || t(`form.${fieldName}`)}{" "}
          {isRequired && <span className="text-danger">*</span>}
        </Label>
      )}
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          if (isPlaintext) {
            return (
              <div className="form-control-plaintext">
                {field?.value?.label}
              </div>
            );
          }

          return (
            <Select
              {...field}
              isDisabled={isDisabled}
              isClearable={isClearable}
              isMulti={isMultiple}
              openMenuOnFocus
              classNamePrefix="select2-selection"
              className={`${formValidate(errors, touchedFields, fieldName)}`}
              placeholder={t("common:placeholder.select", {
                title: title || t(`form.${fieldName}`),
              })}
              options={dataList}
              onChange={data => {
                const oldValue = getValues(fieldName);
                field.onChange(data);

                if (!oldValue || oldValue?.value !== data?.value) {
                  if (typeof onChange === "function") {
                    onChange(data);
                  }
                }
              }}
              components={
                isUseComponents
                  ? {
                      Option: MenuColorSelect,
                      SingleValue: SingleColorSelect,
                    }
                  : {}
              }
            />
          );
        }}
      />
      {isError && !isPlaintext && (
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      )}
    </div>
  );
};

FormSelect.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  dataList: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiple: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
  isUseComponents: PropTypes.bool,
  isLabel: PropTypes.bool,
  isPlaintext: PropTypes.bool,
  isError: PropTypes.bool,
  isClearable: PropTypes.bool,
};

FormSelect.defaultProps = {
  isDisabled: false,
  isRequired: false,
  isMultiple: false,
  onChange: () => {},
  title: "",
  isUseComponents: false,
  isLabel: true,
  isPlaintext: false,
  isError: true,
  isClearable: true,
};

export default FormSelect;
